import React from 'react';

import classNames from 'classnames';
import { connect } from 'react-redux';

import { Box, Stack, Columns, Column } from '@nerdwallet/currency';
import BarChart from './bar-chart/bar-chart';

import {
  PRIVATE_MORTGAGE_INSURANCE,
  CALCULATORS_INPUTS_HASH,
  DOWN_PAYMENT,
  TOTAL_CLOSING_COST,
  MORTGAGE_INSURANCE,
} from './analytics-constants';
import { getFieldNames, showMortgageInsurance, showPMI } from './utils';
import { FIELDS_INPUTS_HASH } from './fields-hash';
import type { Calculator } from '../../lib/analytics-constants';

// @ts-ignore - ignore error
import styles from './monthly-payment.module.less';

interface MonthlyPaymentProps {
  calculator: Calculator;
  /** Indicates wether the component is rendered in ControlPanel or not */
  view?: 'ControlPanel' | 'DownPayments';
}
interface OwnProps extends MonthlyPaymentProps {
  /** Derived from Redux */
  isPMIVisible: boolean;
  isMortgageInsuranceVisible: boolean;
}

const MonthlyPayment = (props: OwnProps): JSX.Element => {
  const { calculator, isPMIVisible, isMortgageInsuranceVisible, view } = props;
  const fieldsToShow = getFieldNames(calculator, view);

  return (
    <Box
      className={classNames(styles.container, {
        [styles.containerHomeAffordability]: calculator === 'homeAffordability',
        [styles.containerControlPanel]: view === 'ControlPanel',
      })}
    >
      <Stack dividers={1} spacing={2}>
        {fieldsToShow.map((fieldName) => {
          const Input = FIELDS_INPUTS_HASH[fieldName];
          const INPUT_ANALYTICS =
            CALCULATORS_INPUTS_HASH?.[calculator]?.[fieldName];

          // Mortgage & Home Affordability hide/show PMI
          if (fieldName === PRIVATE_MORTGAGE_INSURANCE && !isPMIVisible)
            return null;
          if (fieldName === MORTGAGE_INSURANCE && !isMortgageInsuranceVisible)
            return null;

          const FIELDS_WITH_NO_BAR_CHART = [DOWN_PAYMENT, TOTAL_CLOSING_COST];
          const showBarChart = !FIELDS_WITH_NO_BAR_CHART.includes(fieldName);

          return (
            <Columns collapse alignY="center" key={fieldName}>
              <Column width="6">
                <Input
                  calculator={calculator}
                  // @ts-ignore - ignore error
                  view={view}
                  analytics={INPUT_ANALYTICS}
                />
              </Column>
              {showBarChart && (
                <Column width="6">
                  <BarChart calculator={calculator} fieldName={fieldName} />
                </Column>
              )}
            </Columns>
          );
        })}
      </Stack>
    </Box>
  );
};

const mapStateToProps = (state, ownProps: MonthlyPaymentProps) => {
  return {
    isPMIVisible: showPMI(state, ownProps.calculator),
    isMortgageInsuranceVisible: showMortgageInsurance(
      state,
      ownProps.calculator
    ),
  };
};

export default connect(mapStateToProps)(MonthlyPayment);
